<template>
<div class="vliveContentEdit form dialog-form">
    <el-dialog title="添加内容模块" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
            <el-form-item label="模块类型" prop="name">
                <el-radio-group v-model="item.columntype">
                    <el-radio :label="columntype.code" v-for="(columntype, index) in columntypeList" :key="index">{{columntype.name}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="模块名称" prop="columnname">
                <el-input v-model.trim="item.columnname" maxlength="6" show-word-limit clearable placeholder="不超过6个字"></el-input>
            </el-form-item>
            <el-form-item v-if="item.columntype === 11 || item.columntype === 12" label="直播链接" prop="columnurl">
                <el-input v-model.trim="item.columnurl" maxlength="100" show-word-limit clearable placeholder="请填写直播链接"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {saveAndUpdateCwLivetvcolumninfo} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveContentEdit',
    data() {
        let checkColumnUrl = (rule, value, callback) => {
            if ((this.item.columntype === 11 || this.item.columntype === 13) && this.item.columnurl === '') {
                callback(new Error('请填写直播链接'))
            } else {
                callback()
            }
        }
        return {
            dialogVisible: false,
            columntypeAllList: [
                {code: 1, name: '图文信息'},
                {code: 2, name: '嘉宾海报'},
                {code: 3, name: '图文直播'},
                {code: 11, name: '视频直播'},
                {code: 12, name: '图片直播'}
            ],
            columntypeList: [],
            item: {
                liveinnerid: this.$route.query.id ? this.$route.query.id : '',
                innerid: '',
                columntype: 1,
                columnurl: '',
                columnname: '',
                showorder: 1
            },
            rules: {
                columnname: [
                    {required: true, message: '请输入模块名称', trigger: 'blur'},
                    {min: 0, max: 6, message: '不超过6个字', trigger: 'blur'}
                ],
                relinnerid: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                columnurl: [
                    {validator: checkColumnUrl, trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {},
    methods: {
        openDialog(type, row, seat) {
            this.dialogVisible = true
            this.columntypeList = JSON.parse(JSON.stringify(this.columntypeAllList))
            if (type === 'add') {
                this.item = {
                    columnname: '',
                    columntype: 1,
                    columnurl: '',
                    innerid: '',
                    liveinnerid: this.$route.query.id ? this.$route.query.id : '',
                    showorder: seat,
                    status: 1
                }
            } else {
                this.item = row
            }
        },
        cancel() {
            this.$confirm(vliveMsg.cancelVliveOneContent.msg, vliveMsg.cancelVliveOneContent.title, {
                confirmButtonText: vliveMsg.cancelVliveOneContent.confirmText,
                cancelButtonText: vliveMsg.cancelVliveOneContent.cancelText
            }).then(() => {
                this._cancel()
            })
        },
        _cancel() {
            this.$refs.ruleForm.resetFields()
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm(vliveMsg.submitVliveOneContent.msg, vliveMsg.submitVliveOneContent.title, {
                        confirmButtonText: vliveMsg.submitVliveOneContent.confirmText,
                        cancelButtonText: vliveMsg.submitVliveOneContent.cancelText
                    }).then(() => {
                        this._saveliveContent()
                    })
                }
            })
        },
        _saveliveContent() {
            this.setLoading(true)
            saveAndUpdateCwLivetvcolumninfo({
                data: this.item,
                success: data => {
                    this.$message.success(vliveMsg.submitVliveOneContent.successMsg)
                    this.setLoading(false)
                    this._cancel()
                    this.$emit('getVliveContentList')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContentEdit {
    .el-dialog {
        width: 680px;
    }
    .el-input .el-input__count .el-input__count-inner{
        line-height: 28px;
    }
}
</style>
